export const SLUG_PAGE_DATA = {
  kg: {
    city: 'bishkek',
    title: 'Пользовательское соглашение — Ресторан Farfor в Кыргызстане',
    description:
      'Персональные данные получаются в связи с заключением договора, стороной которого является субъект персональных данных. Персональные данные не распространяются, а также не предоставляются третьим лицам без согласия субъекта персональных данных и используются оператором исключительно для исполнения указанного соглашения и заключения договоров с субъектом персональных данных.',
  },
  com: {
    city: 'uralsk',
    title: 'Пользовательское соглашение — Ресторан Farfor в Казахстане',
    description:
      'Персональные данные получаются в связи с заключением договора, стороной которого является субъект персональных данных. Персональные данные не распространяются, а также не предоставляются третьим лицам без согласия субъекта персональных данных и используются оператором исключительно для исполнения указанного соглашения и заключения договоров с субъектом персональных данных.',
  },
  ru: {
    city: 'ufa',
    title: 'Пользовательское соглашение — Ресторан Farfor в России',
    description:
      'Персональные данные получаются в связи с заключением договора, стороной которого является субъект персональных данных. Персональные данные не распространяются, а также не предоставляются третьим лицам без согласия субъекта персональных данных и используются оператором исключительно для исполнения указанного соглашения и заключения договоров с субъектом персональных данных.',
  },
}

export const DEFAULT_SLUG_DATA = {
  city: 'ufa',
  title: 'Пользовательское соглашение — Ресторан Farfor в России',
  description:
    'Персональные данные получаются в связи с заключением договора, стороной которого является субъект персональных данных. Персональные данные не распространяются, а также не предоставляются третьим лицам без согласия субъекта персональных данных и используются оператором исключительно для исполнения указанного соглашения и заключения договоров с субъектом персональных данных.',
}
